import React from 'react';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { DateString } from 'routes/HumanResourcesModule/business/types';
import SimulationEvolutionTooltip from './SimulationEvolutionTooltip';

type Props = {
    value: number;
    simulatedValue?: number;
    isMonthly: boolean;
    date: DateString;
};
const YearlyNeutralEqualityIcon = (
    <HorizontalRuleIcon
        sx={(theme) => ({ color: theme.palette.orange })}
        fontSize="small"
    />
);
const YearlyDecreasingEvolutionIcon = (
    <TrendingDownIcon
        sx={(theme) => ({ color: theme.palette.green })}
        fontSize="small"
    />
);

const YearlyIncreasingEvolutionIcon = (
    <TrendingUpIcon
        sx={(theme) => ({ color: theme.palette.red })}
        fontSize="small"
    />
);
const NeutralEqualityIcon = (
    <DragHandleIcon
        sx={(theme) => ({ color: theme.palette.green })}
        fontSize="small"
    />
);
const DecreasingEvolutionIcon = (
    <KeyboardDoubleArrowDownIcon
        sx={(theme) => ({ color: theme.palette.green })}
        fontSize="small"
    />
);

const IncreasingEvolutionIcon = (
    <KeyboardDoubleArrowUpIcon
        sx={(theme) => ({ color: theme.palette.red })}
        fontSize="small"
    />
);
// Used to display evolution amount in simulations data grid
const SimulationEvolutionIcon = ({
    value,
    simulatedValue,
    isMonthly,
    date,
}: Props): React.ReactElement => {
    if (simulatedValue === undefined || value === simulatedValue) {
        return isMonthly ? NeutralEqualityIcon : YearlyNeutralEqualityIcon;
    }
    const evolutionValue =
        simulatedValue && simulatedValue > 0
            ? ((value - simulatedValue) / simulatedValue) * 100
            : undefined;
    const DecrasingEvolutionIconSelect = isMonthly
        ? DecreasingEvolutionIcon
        : YearlyDecreasingEvolutionIcon;
    const IncreasingEvolutionIconSelect = isMonthly
        ? IncreasingEvolutionIcon
        : YearlyIncreasingEvolutionIcon;
    return (
        <SimulationEvolutionTooltip
            evolutionValue={evolutionValue}
            isMonthly={isMonthly}
            year={parseInt(date.slice(0, 4), 10)}
        >
            {simulatedValue > value
                ? DecrasingEvolutionIconSelect
                : IncreasingEvolutionIconSelect}
        </SimulationEvolutionTooltip>
    );
};

export default React.memo(SimulationEvolutionIcon);
